// extracted by mini-css-extract-plugin
export var parcelRow = "_ve-0";